module.exports = __webpack_public_path__ + "static/pic04.1609dea6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic04.jpg
// module id = 522
// module chunks = 152114997246587